<template>
  <SearchedUserPrimary
    :tenantUser="expert"
    :tenantUserSkills="expert.tenantUserSkills"
  />
</template>

<script>
  import SearchedUserPrimary from '@modules/search/searched-user-primary'

  export default {
    name: 'SearchedUserHorizontal',
    components: {
      SearchedUserPrimary,
    },
    props: {
      expert: {
        type: Object,
        required: false,
        default: () => {},
      },
    },
  };
</script>
